import {DependencyList, useCallback, useEffect, useLayoutEffect, useRef} from "react";

import {debounce} from "@pg-mono/nodash";

export const DYNAMIC_POSITION_ATTRIBUTE = "data-pos";

export interface IDynamicPositionProps {
    [key: string]: number;
}

export const useListDynamicPositions = <TWrapperElementType extends HTMLElement>(refreshDeps: DependencyList = []) => {
    const listWrapperRef = useRef<TWrapperElementType | null>(null);
    const dynamicPosition = useRef(-1);
    const observerRef = useRef<MutationObserver | null>(null);

    const refreshDynamicPositions = useCallback(() => {
        let vIndex = 0;
        (Array.from(listWrapperRef.current?.children || []) as HTMLElement[]).forEach((child) => {
            const isVisible = child.offsetWidth > 0;
            const skipElement = child.getAttribute(DYNAMIC_POSITION_ATTRIBUTE) === "-1";

            if (!skipElement && isVisible) {
                child.setAttribute(DYNAMIC_POSITION_ATTRIBUTE, vIndex.toString());
                vIndex++;
            }
        });
    }, []);

    const disconnectObserver = useCallback(() => {
        observerRef.current?.disconnect();
        observerRef.current = null;
    }, []);

    const setListWrapperRef = useCallback(
        (node: TWrapperElementType | null) => {
            listWrapperRef.current = node;
            disconnectObserver();

            if (!node) {
                return;
            }

            requestAnimationFrame(() => {
                refreshDynamicPositions();
            });

            const observer = new MutationObserver((mutationsList) => {
                const shouldRefresh = mutationsList.some(
                    (mutation) => mutation.type === "childList" || (mutation.type === "attributes" && mutation.attributeName === "class")
                );

                if (shouldRefresh) {
                    requestAnimationFrame(() => {
                        refreshDynamicPositions();
                    });
                }
            });

            observer.observe(node, {attributes: true, childList: true, subtree: true});
            observerRef.current = observer;
        },
        [disconnectObserver, refreshDynamicPositions]
    );

    useEffect(() => {
        const handleResize = debounce(refreshDynamicPositions, 50);

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            disconnectObserver();
        };
    }, [disconnectObserver, refreshDynamicPositions]);

    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            refreshDynamicPositions();
        });
    }, [refreshDynamicPositions, ...refreshDeps]);

    const getDynamicPosition = () => {
        if (dynamicPosition.current === -1) {
            throw new Error("You have to use initializeDynamicPosition before using getDynamicPosition to reset calculation");
        }

        return dynamicPosition.current++;
    };

    const getDynamicPositionProps = (): IDynamicPositionProps => {
        return {
            [DYNAMIC_POSITION_ATTRIBUTE]: getDynamicPosition()
        };
    };

    const initializeDynamicPosition = () => {
        dynamicPosition.current = 0;
    };

    return {
        wrapperProps: {
            ref: setListWrapperRef
        },
        initializeDynamicPosition,
        getDynamicPosition,
        getDynamicPositionProps,
        refreshDynamicPositions
    };
};

export const disableDynamicPositionProps = () => {
    return {
        [DYNAMIC_POSITION_ATTRIBUTE]: -1
    };
};

export const getDynamicPositionCssSelector = (position: number) => `[${DYNAMIC_POSITION_ATTRIBUTE}="${position}"]`;

export const getDynamicPositionsCssSelector = (position: number[]) => position.map(getDynamicPositionCssSelector).join(", ");
import {DependencyList, useCallback, useEffect, useLayoutEffect, useRef} from "react";

import {debounce} from "@pg-mono/nodash";

export const DYNAMIC_POSITION_ATTRIBUTE = "data-pos";

export interface IDynamicPositionProps {
    [key: string]: number;
}

export const useListDynamicPositions = <TWrapperElementType extends HTMLElement>(refreshDeps: DependencyList = []) => {
    const listWrapperRef = useRef<TWrapperElementType | null>(null);
    const dynamicPosition = useRef(-1);
    const observerRef = useRef<MutationObserver | null>(null);

    const refreshDynamicPositions = useCallback(() => {
        let vIndex = 0;
        (Array.from(listWrapperRef.current?.children || []) as HTMLElement[]).forEach((child) => {
            const isVisible = child.offsetWidth > 0;
            const skipElement = child.getAttribute(DYNAMIC_POSITION_ATTRIBUTE) === "-1";

            if (!skipElement && isVisible) {
                child.setAttribute(DYNAMIC_POSITION_ATTRIBUTE, vIndex.toString());
                vIndex++;
            }
        });
    }, []);

    const disconnectObserver = useCallback(() => {
        observerRef.current?.disconnect();
        observerRef.current = null;
    }, []);

    const setListWrapperRef = useCallback(
        (node: TWrapperElementType | null) => {
            listWrapperRef.current = node;
            disconnectObserver();

            if (!node) {
                return;
            }

            requestAnimationFrame(() => {
                refreshDynamicPositions();
            });

            const observer = new MutationObserver((mutationsList) => {
                const shouldRefresh = mutationsList.some(
                    (mutation) => mutation.type === "childList" || (mutation.type === "attributes" && mutation.attributeName === "class")
                );

                if (shouldRefresh) {
                    requestAnimationFrame(() => {
                        refreshDynamicPositions();
                    });
                }
            });

            observer.observe(node, {attributes: true, childList: true, subtree: true});
            observerRef.current = observer;
        },
        [disconnectObserver, refreshDynamicPositions]
    );

    useEffect(() => {
        const handleResize = debounce(refreshDynamicPositions, 50);

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            disconnectObserver();
        };
    }, [disconnectObserver, refreshDynamicPositions]);

    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            refreshDynamicPositions();
        });
    }, [refreshDynamicPositions, ...refreshDeps]);

    const getDynamicPosition = () => {
        if (dynamicPosition.current === -1) {
            throw new Error("You have to use initializeDynamicPosition before using getDynamicPosition to reset calculation");
        }

        return dynamicPosition.current++;
    };

    const getDynamicPositionProps = (): IDynamicPositionProps => {
        return {
            [DYNAMIC_POSITION_ATTRIBUTE]: getDynamicPosition()
        };
    };

    const initializeDynamicPosition = () => {
        dynamicPosition.current = 0;
    };

    return {
        wrapperProps: {
            ref: setListWrapperRef
        },
        initializeDynamicPosition,
        getDynamicPosition,
        getDynamicPositionProps,
        refreshDynamicPositions
    };
};

export const disableDynamicPositionProps = () => {
    return {
        [DYNAMIC_POSITION_ATTRIBUTE]: -1
    };
};

export const getDynamicPositionCssSelector = (position: number) => `[${DYNAMIC_POSITION_ATTRIBUTE}="${position}"]`;

export const getDynamicPositionsCssSelector = (position: number[]) => position.map(getDynamicPositionCssSelector).join(", ");
